"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.parseMindsetPartnerBrands = parseMindsetPartnerBrands;
function parseMindsetPartnerBrands(value, tenantId) {
    const brands = value?.brands;
    if (!Array.isArray(brands) || brands.length > 500)
        throw new TypeError("Invalid partner directory");
    const ids = new Set();
    for (const row of brands) {
        if (!row || typeof row !== "object" || row.tenantId !== tenantId ||
            typeof row.companyId !== "string" || !/^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i.test(row.companyId) || ids.has(row.companyId) ||
            typeof row.name !== "string" || !row.name.length || row.name.length > 255 || typeof row.slug !== "string" ||
            !["ACTIVE", "SUSPENDED", "CLOSED"].includes(row.status) || typeof row.active !== "boolean" ||
            !Number.isSafeInteger(row.revision) || row.revision < 0 || (row.active && row.revision === 0))
            throw new TypeError("Invalid partner directory entry");
        ids.add(row.companyId);
    }
    return brands;
}
//# sourceMappingURL=partner-brands.js.map